import React from 'react';

import classNames from 'classnames';

import compose from '../../../../lib/utils/compose';

import {
  withSettings,
  IWithSettingsProps,
} from '../../../../components/context/settings/index';
import { withI18n, IWithI18nProps } from '../../../../components/context/i18n';
import { withTPA, IWithTPAProps } from '../../../../components/context/tpa';
import EpisodePageNavIndex from '../Nav/EpisodePageNavIndex';
import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

import ErrorIcon from './ErrorIcon';

interface IEpisodePageErrorProps
  extends IWithSettingsProps,
    IWithI18nProps,
    IWithTPAProps {
  error: any;
  episode: IPodcastEpisode;
}

import styles from './Error.scss';
import getStyles from './Error.styles';

function EpisodePageError({
  error,
  episode,
  settings,
  tpa,
  t,
}: IEpisodePageErrorProps) {
  const dynamicStyles = getStyles({
    colors: settings.colors,
    fonts: settings.fonts,
    deviceType: tpa.params.deviceType,
  });

  return (
    <div
      data-hook="episode.error"
      className={classNames(styles.errorWrapper, dynamicStyles.errorWrapper)}
    >
      <EpisodePageNavIndex
        className={styles.backButtonLayout}
        episode={episode}
      />
      <ErrorIcon
        className={classNames(styles.errorIcon, dynamicStyles.errorIcon)}
      />
      <h2
        data-hook="episode.error.title"
        className={classNames(styles.errorTitle, dynamicStyles.errorTitle)}
      >
        {error && error.statusCode === 404
          ? t('pages.episode.not-found-title')
          : t('pages.episode.unexpected-error-title')}
      </h2>
    </div>
  );
}

export default compose(withI18n, withTPA, withSettings)(EpisodePageError);
